export default __webpack_public_path__ + "static/media/prevention-logo.33a686e5.svg";